// import { useSettings } from "@/core/settingStore";

import { cn } from "@/utils";
import type { ReactNode } from "react";
import AccountDropdown from "../components/account-dropdown";
import BreadCrumb from "../components/bread-crumb";
import DeployTrackBadge from "../components/deploy-track-badge";
// import NoticeButton from "../components/notice";

// import SettingButton from "../components/setting-button";

interface HeaderProps {
	leftSlot?: ReactNode;
}

export default function Header({ leftSlot }: HeaderProps) {
	// const { breadCrumb } = useSettings();
	return (
		<header
			data-slot="slash-layout-header"
			className={cn(
				"sticky top-0 left-0 right-0 z-app-bar",
				"flex items-center justify-between px-2 grow-0 shrink-0",
				"bg-background/60 backdrop-blur-xl",
				"h-[var(--layout-header-height)] ",
			)}
		>
			<div className="flex items-center">
				{leftSlot}

				<div className="hidden md:block ml-4">
					{/* {breadCrumb && <BreadCrumb />} */}
					<BreadCrumb />
				</div>
			</div>

			<div className="flex items-center gap-1">
				{/* <SearchBar /> */}
				{/* <Button
					variant="ghost"
					size="icon"
					className="rounded-full"
					onClick={() => window.open("https://github.com/d3george/slash-admin")}
				>
					<Icon icon="mdi:github" size={24} />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					className="rounded-full"
					onClick={() => window.open("https://discord.gg/fXemAXVNDa")}
				>
					<Icon icon="carbon:logo-discord" size={24} />
				</Button> */}
				{/* <NoticeButton />
				<SettingButton /> */}
				<DeployTrackBadge />
				<AccountDropdown />
			</div>
		</header>
	);
}
